var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-notification"},[_c('div',{class:_vm.iconModifiers}),_vm._v(" "),_c('div',{class:_vm.contentModifiers,domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('div',{staticClass:"side-notification__close",on:{"click":_vm.onClose}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98072d1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generics/side-notification/side-notification.vue
// module id = hZIU
// module chunks = 0